import React, { useState, useEffect, useRef } from 'react';
import { MoreVertical } from 'lucide-react';

const actionVariantStyles = {
  default: 'text-secondary hover:bg-gray-50',
  danger: 'text-red-600 hover:bg-red-50',
  success: 'text-emerald-600 hover:bg-emerald-50',
  warning: 'text-amber-600 hover:bg-amber-50',
};

const ActionDropdown = ({ actions = [], className = '' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const visibleActions = actions.filter((action) => action.visible !== false);

  if (visibleActions.length === 0) return null;

  const handleActionClick = (action) => {
    setIsOpen(false);
    action.onClick?.();
  };

  return (
    <div className={`relative inline-block text-left ${className}`} ref={dropdownRef}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="p-2 rounded-btn text-secondary hover:bg-gray-100 transition-colors focus:outline-none focus:ring-2 focus:ring-brand/30"
        aria-label="Actions"
      >
        <MoreVertical className="w-4 h-4" />
      </button>

      {isOpen && (
        <div className="absolute right-0 z-50 mt-1 w-48 origin-top-right rounded-card bg-white shadow-medium border border-gray-100 py-1 animate-in fade-in duration-150">
          {visibleActions.map((action, index) => {
            const Icon = action.icon;
            return (
              <button
                key={action.label || index}
                type="button"
                onClick={() => handleActionClick(action)}
                className={`
                  w-full flex items-center gap-2 px-4 py-2 text-left text-sm transition-colors
                  ${actionVariantStyles[action.variant] || actionVariantStyles.default}
                `}
              >
                {Icon && <Icon className="w-4 h-4 shrink-0" />}
                <span>{action.label}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ActionDropdown;
